// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fCurrency } from '../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: '#005249',
  backgroundColor: '#C8FACD',
}));

// ----------------------------------------------------------------------

export default function TotalRev(props) {
  const { rev, title } = props;
  return (
    <RootStyle style={{ borderRadius: '16px', fontFamily: 'Public Sans, sans-serif' }}>
      <Typography variant="h3">{fCurrency(rev)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title ? title : 'Revenue Generated'}
      </Typography>
    </RootStyle>
  );
}
